import { useState } from "react";
import styled from "styled-components";
import { Segmented } from "antd";
import FreeTextViewer from "./FreeTextViewer";
import { hasFreeTextContent } from "./freeTextConfig";

type Language = "ko" | "en";

interface Props {
  html?: string | null;
  htmlEn?: string | null;
  // 본문 내 검색(EditorSearch)이 찾는 영역 id
  id?: string;
}

const LANGUAGE_KEY = "atlas-post-language";

const loadLanguage = (): Language => {
  try {
    return localStorage.getItem(LANGUAGE_KEY) === "en" ? "en" : "ko";
  } catch {
    return "ko";
  }
};

// 게시글 열람 화면의 FreeText 본문. 영문 버전이 있을 때만 한국어 / English 전환을 보여준다
const FreeTextContent = ({ html, htmlEn, id }: Props) => {
  const hasEnglish = hasFreeTextContent(htmlEn);
  const [language, setLanguage] = useState<Language>(loadLanguage);

  const changeLanguage = (value: Language) => {
    setLanguage(value);
    try {
      localStorage.setItem(LANGUAGE_KEY, value);
    } catch {
      // 저장소를 못 쓰는 환경이면 이번 화면에서만 유지
    }
  };

  const showEnglish = hasEnglish && language === "en";

  return (
    <>
      {hasEnglish && (
        <LanguageBar>
          <Segmented<Language>
            size="small"
            value={language}
            onChange={changeLanguage}
            options={[
              { value: "ko", label: "한국어" },
              { value: "en", label: "English" },
            ]}
          />
        </LanguageBar>
      )}
      <FreeTextViewer id={id} html={showEnglish ? htmlEn : html} />
    </>
  );
};

const LanguageBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
`;

export default FreeTextContent;
